// extracted by mini-css-extract-plugin
export default {"main":"Welcome_main__8s1Uw","welcomeText":"Welcome_welcomeText__jDtXQ"};